import { API_BASE_URL } from "@/constants";

export const API_VESSEL_GROUPS = (id = 1) => {
  return `${API_BASE_URL}/admin/vessel_groups/${id}.json`;
};

export const API_VESSEL_REPORT = () => {
  return `${API_BASE_URL}/vessel_reports.json`;
};

export const API_ADMIN_VESSEL_GROUP = () => {
  return `${API_BASE_URL}/admin/vessel_groups.json`;
};

export const API_GET_ADMIN_VESSELS = () => {
  return `${API_BASE_URL}/admin/vessels.json`;
};

export const API_GET_VESSELS = () => {
  return `${API_BASE_URL}/api/vessels.json`;
};

export const API_GET_BASE_STATIONS = () => {
  return `${API_BASE_URL}/api/base_stations.json`;
};

export const API_GET_NAVIGA_STATUS = () => {
  return `${API_BASE_URL}/admin/navigation_statuses.json`;
};

export const API_GET_SHIP_TYPE = (id = "") => {
  const params = id ? `/${id}` : "";
  return `${API_BASE_URL}/admin/ship_types${params}.json`;
};

export const API_GET_NOTIFICATION = (id = "") => {
  const params = id ? `/${id}` : "";
  return `${API_BASE_URL}/event_notifications${params}.json`;
};

export const API_MAKE_READ = id => {
  return `${API_BASE_URL}/event_notifications/${id}/mark_as_read`;
};

export const API_MAKE_READ_ALL = () => {
  return `${API_BASE_URL}/event_notifications/mark_all_as_read`;
};

export const API_UNREAD_COUNT_NOTIFY = () => {
  return `${API_BASE_URL}/event_notifications/count_unread.json`;
};

export const API_POSITION_TYPE_FIXES = () => {
  return `${API_BASE_URL}/admin/position_type_fixes.json`;
};

export const API_GET_MIDS = () => {
  return `${API_BASE_URL}/admin/mids.json`;
};

export const API_ADMIN_GET_ZONE = () => {
  return `${API_BASE_URL}/admin/zones.json`;
};

export const API_SIGN_OUT = () => {
  return `${API_BASE_URL}/users/sign_out`;
};

export const API_SING_IN = () => {
  return `${API_BASE_URL}/users/sign_in.json`;
};
